import config from '@actr/config';
import { additionalProductsTypes } from '@actr/specs/src/avia/additional-products-types';
import { insurancesTypes } from '@actr/specs/src/avia/insurances-types';
import { paymentOptions } from '@actr/specs/src/payment/options';
import { ProjectNames } from '@actr/specs/src/project/names';
import { ProjectTypes } from '@actr/specs/src/project/types';
import { ThemeName } from '@actr/specs/src/theme-name';
import merge from 'lodash/merge';

import type { LocalConfig } from './specs';

const baseConfig: LocalConfig = merge(config, {
  theme: ThemeName.AVIAKASSA,
  projectType: ProjectTypes.AK_REDESIGN,
  rootId: 'aviakassa-v2-app',
  payment: {
    excludedPayments: [paymentOptions.TINKOFF_PAY]
  },
  YM_TrackingID: '85926445',
  project: ProjectNames.V2_SITE,
  isAlternative: false,
  partnerLegacyFormSrc: 'https://widgets.aviakassa.com/legacy/partner.js',
  navigation: {
    useRouterFor: {
      redirectToAviaResults: true,
      redirectToAviaBooking: true,
      redirectToAviaCheckout: true,
      redirectToAviaPostBooking: true,
      redirectToHome: true
    }
  },
  avia: {
    enableAdditionalServiceInPostBook: false,
    enableAdditionalServiceInPostSale: true,
    enablePlaceChooseInPostBook: false,
    enableExtraBaggageInPostBook: false,
    waitPaymentInterval: 5000,
    topInsurances: [insurancesTypes.FLIGHT_REFUND, insurancesTypes.ALFA_LOSS_CONNECTION],
    topAdditionalProducts: [additionalProductsTypes.ONLINE_REGISTRATION],
    usePostBookingPages: true,
    enableRebook: false,
    useFastFlightInfo: true,
    enablePostSale: true,
    insurancesShowedAsAdditionalProduct: [insurancesTypes.GOOD_WEATHER],
    orderState: {
      changes: {
        requestTimeLimit: 10000
      },
      realBook: {
        interval: 10000,
        maxTries: 15
      }
    },
    enableAviaHotelsPromotion: true
  },
  hotel: {
    enableYandexTravel: false
  }
});

export default baseConfig;
